export default class YearSelect {
  constructor() {
    this.#init();
  }

  #init() {
    var yearDialog = $("#year-select-menu");
    var yearSelect = $(
      "#year-label, #year-text-from, #year-from, #year-text-until, #year-until"
    );

    yearSelect.on("click", () => {
      $(yearDialog).dialog({
        resizable: false,
        modal: true,
        width: 400,
        buttons: {
          Abbrechen: function () {
            $(this).dialog("close");
          },
          Anwenden: function () {
            $(this).dialog("close");

            var selectedType = $("#type-year")
              .children("input:checked")
              .attr("id");

            var selectedFromYear = $("#slider-year-from").text();
            var selectedUntilYear = $("#slider-year-until").text();
            if (selectedUntilYear == "") 2023;

            $("#slider-year-until").text();

            if (selectedType == "static") {
              $("#year-from").text(selectedFromYear);
              $("#year-from").attr("data-year", selectedFromYear);
              $("#year-text-from").css("display", "none");
              $("#year-text-until").css("display", "none");
              $("#year-until").text("");
              $("#year-until").attr("data-year", "");
            } else if (selectedType == "difference") {
              $("#year-from").text(selectedFromYear);
              $("#year-from").attr("data-year", selectedFromYear);
              $("#year-until").text(selectedUntilYear);
              $("#year-until").attr("data-year", selectedUntilYear);
              $("#year-text-from").css("display", "block");
              $("#year-text-until").css("display", "block");
            }
          },
        },
      });

      // @ts-ignore
      var typeSelect = $("#type-year").children("input").checkboxradio();
      var rangeSliderYear = $("#range-slider-year").slider({
        range: true,
        min: 2012,
        max: 2023,
        values: [Number($("#slider-year-from").text()), 2023],
        slide: function (event: any, ui: any) {
          $("#slider-year-from").text(ui.values[0]).css("display", "block");
          $("#text-decoration").css("display", "block");
          $("#slider-year-until").text(ui.values[1]).css("display", "block");
        },
      });
      var sliderYear = $("#slider-year").slider({
        min: 2012,
        max: 2023,
        value: Number($("#slider-year-from").text()),
        slide: function (event: any, ui: any) {
          $("#slider-year-until").css("display", "none");
          $("#year-decoration").css("display", "none");
          $("#slider-year-from").text(ui.value).css("display", "block");
        },
      });

      if (typeSelect[0].checked && typeSelect[0].id == "static") {
        rangeSliderYear.slider("destroy");
        $("#slider-year-until").css("display", "none");
        $("#year-decoration").css("display", "none");
        $("#slider-year-from")
          .text($("#year-from").text())
          .css("display", "block");
        sliderYear.slider("value", $("#year-from").text());
      } else if (typeSelect[1].checked && typeSelect[1].id == "difference") {
        sliderYear.slider("destroy");
        $("#slider-year-until").css("display", "block");
        $("#year-decoration").css("display", "block");
      }

      typeSelect.on("change", (event: any) => {
        if (event.target.id == "static") {
          if (rangeSliderYear.slider("instance") != undefined)
            rangeSliderYear.slider("destroy");

          $("#slider-year-until").css("display", "none");
          $("#year-decoration").css("display", "none");
          $("#slider-year-from")
            .text($("#slider-year-from").text())
            .css("display", "block");

          sliderYear.slider({
            min: 2012,
            max: 2023,
            value: ($("#slider-year-from").text() || 2016) as any,
            slide: function (event: any, ui: any) {
              $("#slider-year-until").css("display", "none");
              $("#year-decoration").css("display", "none");
              $("#slider-year-from").text(ui.value).css("display", "block");
            },
          });
        } else {
          if (sliderYear.slider("instance") != undefined)
            sliderYear.slider("destroy");

          $("#slider-year-until").css("display", "block");
          $("#year-decoration").css("display", "block");
          $("#slider-year-from")
            .text($("#slider-year-from").text())
            .css("display", "block");
          $("#slider-year-until").text(2023).css("display", "block");

          rangeSliderYear.slider({
            range: true,
            min: 2012,
            max: 2023,
            values: ([$("#slider-year-from").text(), 2023] || [
              2016, 2023,
            ]) as any,
            slide: function (event: any, ui: any) {
              $("#slider-year-from").text(ui.values[0]).css("display", "block");
              $("#year-decoration").css("display", "block");
              $("#slider-year-until")
                .text(ui.values[1])
                .css("display", "block");
            },
          });
        }
      });
    });
  }
}
